import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom';
import { Container } from '../../../base/Container';
import AppToaster from '../../../commonLib/AppToaster';
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext';
import { MyAlert } from '../../../commonLib/MyAlert';
import { loadingContext } from '../../../commonLib/_lodingContext';
import * as productionWageVoucherCrud from '../../../_crud/vouchers/productionWageVoucherCrud'
import { AdvanceView } from '../../Global/Elements/AdvanceView';
import { DefectView } from '../../Global/Elements/DefectView';
import { TimelineHistory } from '../../Global/TimelineHistory';
import { PrintStarterDash } from '../../Prints/PrintStaterDash';
import { ProductionVoucherPrint } from '../../Prints/ProductionVoucherPrint';
import ProductionItemView from './ProductionItemView';
import { getIsPrint } from '../../../config/GlobalSettings';

export function ProductionVoucherDashboard() {
    const [isLoading, setIsLoading] = useContext(loadingContext)
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [productionWageVoucher, setProductionWageVoucher] = useState()
    const [voucherPayment, setVoucherPayment] = useState([])
    const [advanceData, setAdvanceData] = useState()
    const [defectData, setDefectData] = useState()
    const [voucherDetails, setVoucherDetails] = useState([])
    const history = useHistory();
    const { id } = useParams()

    function doRefresh() {
        getProductionVoucher()
    }

    useEffect(() => {
        getProductionVoucher()
    }, []);

    function getProductionVoucher() {
        setIsLoading(true);
        productionWageVoucherCrud.GetVoucherById(id)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        let hpayment = res.data.data.payments
                        let hdetails = res.data.data.details
                        setProductionWageVoucher(hdata)
                        setVoucherDetails(hdetails)
                        setVoucherPayment(hpayment)
                    }
                    else {
                    }
                }
                else {
                }
                setIsLoading(false);
            })
            .catch(error => {
                setIsLoading(false);
            })
    }

    const DeleteItem = (id) => {
        setIsLoadingMini(true)
        productionWageVoucherCrud.VoucherRemove(id)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false)
                    AppToaster('Deleted successfully.', 'success')
                    history.goBack()
                }
                else {
                    setIsLoadingMini(false)
                    AppToaster('Using by someone,could not delete.', 'error')
                }

            }).catch(error => {
                setIsLoadingMini(false)
                AppToaster('Network error', 'error')
            })
    }

    const printRef = useRef();

    return (
        <>
            {getIsPrint && <div style={{ display: "none" }}>
                <ProductionVoucherPrint paid={productionWageVoucher && productionWageVoucher.paid} pending={productionWageVoucher && productionWageVoucher.pending} productionVoucher={productionWageVoucher && productionWageVoucher.voucher} voucherPayment={voucherPayment} voucherDetails={voucherDetails} ref={printRef} />
            </div>}
            <Container title="Production Voucher Dashboard" doRefresh={doRefresh} isBack="true">

                {getIsPrint && productionWageVoucher && voucherPayment && voucherDetails &&
                    <div class="btn-group pull-right">
                        <PrintStarterDash printRef={printRef} />
                    </div>
                }
                <div class="btn-group">
                    <MyAlert confirmBtnText="Yes, delete it!" title="Delete" param={id} onConfirm={DeleteItem}>
                        <i class="ace-icon fa fa-trash-o bigger-160"></i>
                    </MyAlert>
                </div>
                <div class="hr dotted"></div>
                <div className="row">
                    <div className="col-lg-8">
                        <ProductionItemView advance={advanceData} defect={defectData} paid={productionWageVoucher && productionWageVoucher.paid} pending={productionWageVoucher && productionWageVoucher.pending} productionVoucher={productionWageVoucher && productionWageVoucher.voucher} voucherPayment={voucherPayment} voucherDetails={voucherDetails} doRefresh={getProductionVoucher} />
                    </div>

                    <div className="col-lg-4">
                        {productionWageVoucher && <AdvanceView advanceData={setAdvanceData} contactid={productionWageVoucher.voucher.contact.id} />}
                        <br />
                        {productionWageVoucher && <DefectView defectData={setDefectData} contactid={productionWageVoucher.voucher.contact.id} />}
                        <br />
                        <TimelineHistory id={id} type={1} pageSize={10} text="Processing Voucher Timeline" />
                    </div>

                </div>

            </Container>
        </>
    )
}
